import React, { useContext, useEffect } from 'react';
import { connect } from 'react-redux';

import PrimaryButton from '@modules/common/components/buttons/PrimaryButton';
import { AuthenticationContext } from '@src/config/default/modules/Authentication/components/context';
import { StoreState } from '@src/meta/types/store';
import { setUserAlreadyHadTrial } from '@src/actions/auth';
import UserResource from '@src/services/Identity/UserResource';

import { AccountStatusInfoProps, AccountValidityCheckmark } from './statusInfo';
import { onCreateTrial } from './utils';
import { UpgradeAccount } from './components';

function FreeAccount({
  shAccount,
  userId,
  alreadyHadTrial,
  setUserAlreadyHadTrial,
}: AccountStatusInfoProps & {
  userId: string;
  alreadyHadTrial: boolean | undefined;
  setUserAlreadyHadTrial: (b: boolean) => void;
}) {
  const { maintenanceInProgress } = useContext(AuthenticationContext);
  useEffect(() => {
    const fetchAndSetTrialAvailability = async () => {
      try {
        const res = await UserResource.checkTrialAvailability({ userId });
        setUserAlreadyHadTrial(res);
      } catch (err) {
        // fallback to display button, it will fail in any case if already had a trial.
        setUserAlreadyHadTrial(false);
      }
    };
    if (alreadyHadTrial === undefined) {
      fetchAndSetTrialAvailability();
    }
  }, []);
  return (
    <div style={{ textAlign: 'center' }}>
      <AccountValidityCheckmark shAccount={shAccount} />
      <div style={{ marginBottom: '1rem' }} />
      <div>
        {!maintenanceInProgress && alreadyHadTrial === false && (
          <>
            <PrimaryButton onClick={() => onCreateTrial(shAccount.id, userId)}>
              Create a trial account
            </PrimaryButton>
            <p style={{ margin: '0.75rem 0' }}>or</p>
          </>
        )}
        <UpgradeAccount />
      </div>
    </div>
  );
}

const mapStateToProps = (state: StoreState) => ({
  alreadyHadTrial: state.auth.userAlreadyHadTrial,
});
const mapDispatchToProps = {
  setUserAlreadyHadTrial,
};

export default connect(mapStateToProps, mapDispatchToProps)(FreeAccount);
